import {
  createReducer
} from 'utils';

import {
  PROFILE_INTEGRATIONS_SET_BUTTON
} from '../../constants/profile';

import i18n from '../../i18n';

export default createReducer({
  type: 'button',
  label: i18n.t(['profile-integrations', 'Book Now!'])
}, {
  [PROFILE_INTEGRATIONS_SET_BUTTON]: (state, {payload: {button}}) => Object.assign({}, state, button)
});



// WEBPACK FOOTER //
// ./src/reducers/profile/integrations.js